(function(module) {
    'use strict';
    module.factory('ErrorHandler', ['$state', '$mdToast', '$mdMedia', 'StateQueue', function($state, $mdToast, $mdMedia, StateQueue) {
        var toast;
        var errors = {
            FORBIDDEN: 'No tienes permiso para acceder',
            UNAUTHORIZED: 'Necesitas acceder con tus credenciales, por favor inicia sesión',
            ALREADY_LOGIN: 'Ya haz iniciado sesión'
        };
        var showToast = function(message, delay) {
            if($mdMedia('gt-xs')) {

                delay = delay || 8000;
                var toast = $mdToast
                .simple()
                .textContent(message).hideDelay(delay);
                $mdToast.show(toast);
            }
        };
        var errorActions = {
            UNAUTHORIZED: function(error) {
                showToast(error.message);
                $state.go('auth');
            },
            ALREADY_LOGIN: function(error, toState, fromState) {
                showToast(error.message, 2000);

                if (!fromState.name) {
                    $state.go('main.home');
                }
            }
        };
        var handler = {
            state: function(error, toState, toParams, fromState, fromParams) {
                //TODO is dev
                console.error(error);
                if (errorActions[error.code]) {
                    errorActions[error.code](error, toState, toParams, fromState, fromParams);
                    StateQueue.push(toState);
                }
                if (toast) {

                }
            },
            create: function(code) {
                var message = errors[code] ? errors[code] : errors.default;
                var err = new Error(message);
                err.code = code;

                return err;
            }
        };
        return handler;
    }]);
}(angular.module('emarket.commons')));
